'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Chart = require('./Chart');

var _Chart2 = _interopRequireDefault(_Chart);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var annotationDatasetDefaults = {
  label: '',
  borderColor: 'rgba(255, 255, 255, 0)',
  borderDash: [4, 5],
  pointBorderWidth: 0,
  pointHoverBorderWidth: 1,
  pointRadius: 0,
  pointStyle: 'line',
  fill: false,
  borderWidth: 1,
  data: []
};
var datasetDefaults = {
  label: '',
  borderColor: 'rgba(255, 255, 255, 0)',
  pointBorderWidth: 0,
  pointRadius: 0,
  pointStyle: 'line',
  fill: true,
  borderWidth: 1,
  data: []
};
var annotationDefaults = {
  type: 'line',
  mode: 'horizontal',
  scaleID: 'y-axis-0',
  value: 0,
  borderColor: 'rgba(255, 255, 255, 0)',
  borderDash: [4, 5],
  borderWidth: 1,
  label: {
    enabled: false
  }
};
var scaleYDefaults = {
  gridLines: {
    color: 'rgba(243,252,255, 1)',
    lineWidth: 2
  }
};

var ChartContainer = function (_Component) {
  _inherits(ChartContainer, _Component);

  function ChartContainer(props) {
    _classCallCheck(this, ChartContainer);

    var _this = _possibleConstructorReturn(this, (ChartContainer.__proto__ || Object.getPrototypeOf(ChartContainer)).call(this, props));

    _this.interval = null;
    _this.gradientInterval = null;
    _this.frame = 0;
    _this.currentIndex = [];
    _this.maxY = 0;
    _this.minY = 999999999;
    _this.unitLabel = '';
    _this.chart = null;
    _this.id = null;
    _this.chartData = {
      labels: [],
      datasets: []
    };
    _this.chartOptions = {
      title: {
        display: true,
        lineHeight: 0,
        padding: 1
      },
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        }
      },
      scales: {
        xAxes: [{
          gridLines: {
            display: false,
            backgroundColor: 'rgba(243,252,255, 1)',
            drawOnChartArea: false,
            tickMarkLength: 12,
            color: '#e2e2e2'
          },
          ticks: {
            fontColor: '#8b959e',
            autoSkip: true,
            autoSkipPadding: 10,
            maxRotation: 0,
            source: 'labels',
            callback: function callback(originalTick, index, array) {
              var tick = parseInt(originalTick);

              var start = _moment2.default.unix(array[0]);

              var end = _moment2.default.unix(array[array.length - 1]);

              if (tick <= 0) {
                return '';
              }

              var duration = _moment2.default.duration(end.diff(start));

              var daysDuration = duration.asDays();

              var date = _moment2.default.unix(tick).format('DD.MM');

              if (daysDuration !== NaN && daysDuration < 1) {
                date = _moment2.default.unix(tick).format('HH:ss');
              }

              return date === 'Invalid date' ? originalTick : date;
            }
          },
          distribution: 'series',
          barThickness: 'flex'
        }],
        yAxes: [{
          gridLines: {
            color: 'rgba(243,252,255, 1)',
            lineWidth: 2
          },
          ticks: {
            steps: 10,
            stepValue: 5
          }
        }]
      },
      legend: {
        labels: {
          usePointStyle: true
        },
        position: 'bottom',
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      },
      tooltips: {
        mode: 'label',
        intersect: false,
        enabled: false,
        custom: function custom(toolTipModel) {
          var label = document.getElementById('label-' + _this.id);
          var date = document.getElementById('date-' + _this.id);
          label.innerHTML = '';
          date.innerHTML = '';
          date.style.display = 'none';

          if (!toolTipModel.body) {
            return;
          }

          label.setAttribute('data-coordinates', JSON.stringify(toolTipModel.dataPoints));

          if (_this.chart && _this.chart.chartInstance && toolTipModel.dataPoints.length > 0) {
            var point = toolTipModel.dataPoints[0];
            var index = point.index;
            var xLabel = _this.chart.chartInstance.config.data.labels[index];
            var chartArea = _this.chart.chartInstance.chartArea;

            var dateTime = _moment2.default.unix(xLabel).format('DD.MM.YYYY HH:ss');

            date.style.left = toolTipModel.caretX + 'px';
            date.style.top = chartArea.bottom + 90 + 'px';
            date.style.display = dateTime !== 'Invalid date' ? 'block' : 'none';
            date.innerHTML = dateTime;
          }

          var maxWidth = toolTipModel.body.reduce(function (output, element) {
            var value = element.lines[0].split(':');
            return Math.max(output, value[1] ? value[1].trim().length * 10 : 50);
          }, 50) + _this.unitLabel.length * 3;
          label.style.left = toolTipModel.caretX + (maxWidth - 10) / 2 + 'px';
          label.style.top = _this.props.height / 3 + 'px';
          label.style.width = maxWidth + 10 + 'px';

          if (toolTipModel.body.length > 1) {
            label.style.width = maxWidth * 2 + 40 + 'px';
            label.style.left = toolTipModel.caretX - maxWidth + 40 + 'px';
            label.style.display = 'block';
          }

          toolTipModel.body.map(function (element, index) {
            var span = document.createElement('span');

            if (toolTipModel.labelColors[index]) {
              span.style.backgroundColor = toolTipModel.labelColors[index].borderColor;
            }

            span.style.marginTop = '10px';
            span.style.width = maxWidth + 'px';

            if (toolTipModel.body.length > 1) {
              span.style.marginRight = '20px';
              span.style.display = 'block';
              span.style.float = 'left';
            }

            var value = element.lines[0].split(':');
            span.innerHTML = value[1] ? Number(value[1].trim()).toFixed(Number(_this.props.precision === undefined ? 1 : _this.props.precision)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' ' + _this.unitLabel : '';
            label && label.appendChild(span);
            return null;
          });
        }
      },
      hover: {
        mode: 'nearest',
        intersect: true
      },
      animation: {
        duration: 0,
        easing: 'easeOutElastic'
      },
      annotation: {
        events: ['mouseover'],
        annotations: []
      }
    };

    _this.bindRef = function (_ref) {
      var ref = _ref.ref,
          name = _ref.name;
      _this[name] = ref;
    };

    _this.setDatasets = function () {
      var datasets = _this.props.datasets;
      _this.chartData.datasets = datasets ? datasets.reduce(function (output, datasetData) {
        var dataset = _extends({}, datasetDefaults, datasetData);

        if (dataset.datasetType === 'annotation') {
          dataset = _extends({}, annotationDatasetDefaults, datasetData);
        }

        return [].concat(_toConsumableArray(output), [dataset]);
      }, []) : [];
    };

    _this.id = Math.random();

    _this.setDatasets();

    _this.setAnnotations();

    _this.setAxis();

    _this.state = {
      datasets: !props.isBarChart && props.animationDuration ? _this.getDatasets({
        datasets: _this.chartData.datasets,
        modificator: function modificator() {
          return 0;
        }
      }) : _this.chartData.datasets,
      isAnimated: !props.isBarChart && props.animationDuration ? false : true
    };
    return _this;
  }

  _createClass(ChartContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          animationDuration = _props.animationDuration,
          isBarChart = _props.isBarChart;
      var datasets = this.state.datasets;
      var intervalKeys = animationDuration / 1000 * 60;
      var framePortion = Math.floor(intervalKeys / this.getMaxDatasetLength({
        datasets: this.chartData.datasets
      }));

      if (!isBarChart && animationDuration && this.chartData.datasets.length > 0) {
        this.interval = setInterval(function () {
          if (_this2.frame > intervalKeys) {
            clearInterval(_this2.interval);

            _this2.setState({
              isAnimated: true
            });

            return;
          }

          datasets.map(function (dataset, datasetIndex) {
            if (dataset.datasetType !== 'annotation') {
              var currentIndex = _this2.currentIndex[datasetIndex] !== undefined ? _this2.currentIndex[datasetIndex] : -1;

              if (_this2.frame % framePortion === 0) {
                datasets[datasetIndex].data[currentIndex] = _this2.chartData.datasets[datasetIndex].data[currentIndex];
                ++currentIndex;
              }

              datasets[datasetIndex].data[currentIndex] = Math.floor(Math.min(datasets[datasetIndex].data[currentIndex] + _this2.chartData.datasets[datasetIndex].data[currentIndex] / framePortion, _this2.chartData.datasets[datasetIndex].data[currentIndex]));
              _this2.currentIndex[datasetIndex] = currentIndex;
            }
          });

          _this2.setState({
            datasets: datasets
          }, function () {
            _this2.chart && _this2.chart.chartInstance.update();
          });

          ++_this2.frame;
        }, 18);
      }

      if (!isBarChart) {
        this.gradientInterval = setInterval(function () {
          if (!_this2.chart || _this2.chart && !_this2.chart.chartInstance) {
            return;
          }

          clearInterval(_this2.gradientInterval);
          var gradientData = {};
          Object.keys(_this2.chartData.datasets).map(function (datasetIndex) {
            var maxPixelValue = _this2.chart && _this2.chart.chartInstance.scales['y-axis-0'].getPixelForValue(Math.max.apply(Math, _toConsumableArray(_this2.chartData.datasets[datasetIndex].data)));

            gradientData[datasetIndex] = {
              maxPixelValue: maxPixelValue
            };
          });

          _this2.setState({
            gradientData: gradientData
          });
        }, 400);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.interval);
      clearInterval(this.gradientInterval);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var isBarChart = this.props.isBarChart;
      var _state = this.state,
          datasets = _state.datasets,
          isAnimated = _state.isAnimated,
          gradientData = _state.gradientData;

      var decoratedData = function decoratedData(canvas) {
        var ctx = canvas.getContext('2d');
        return _extends({}, _this3.chartData, {
          datasets: datasets ? datasets.map(function (dataset, index) {
            if (dataset.datasetType === 'annotation') {
              return dataset;
            }

            var gradientDataForDataset = gradientData && gradientData[index];

            if (!gradientDataForDataset || isBarChart) {
              return dataset;
            }

            var gradient = ctx.createLinearGradient(0, gradientDataForDataset.maxPixelValue ? gradientDataForDataset.maxPixelValue : 0, 0, Math.floor(_this3.props.height));
            gradient.addColorStop(0, dataset.backgroundColorStart);
            gradient.addColorStop(0.9, dataset.backgroundColorEnd);
            return _extends({}, dataset, {
              backgroundColor: gradient
            });
          }) : []
        });
      };

      return datasets.length > 0 && _react2.default.createElement(_Chart2.default, _extends({}, this.props, {
        id: this.id,
        isAnimated: isAnimated,
        data: decoratedData,
        options: _extends({
          id: this.id
        }, this.chartOptions),
        bindRef: this.bindRef
      }));
    }
  }, {
    key: 'getDatasets',
    value: function getDatasets(_ref2) {
      var datasets = _ref2.datasets,
          modificator = _ref2.modificator;
      return datasets ? datasets.reduce(function (output, dataset) {
        var newDataset = _extends({}, dataset);

        if (modificator) {
          newDataset.data = newDataset.data.map(modificator);
        }

        output.push(newDataset);
        return output;
      }, []) : [];
    }
  }, {
    key: 'getMaxDatasetLength',
    value: function getMaxDatasetLength(_ref3) {
      var datasets = _ref3.datasets;
      return datasets ? datasets.reduce(function (currentMax, dataset) {
        return Math.max(currentMax, dataset.data.length);
      }, 0) : 0;
    }
  }, {
    key: 'setAnnotations',
    value: function setAnnotations() {
      var _props2 = this.props,
          annotations = _props2.annotations,
          unitLabel = _props2.unitLabel;
      this.chartOptions.annotation.unitLabel = unitLabel;
      this.chartOptions.annotation.annotations = annotations ? annotations.reduce(function (output, annotation) {
        annotation = _extends({}, annotationDefaults, annotation);
        return [].concat(_toConsumableArray(output), [annotation]);
      }, []) : [];

      if (annotations && annotations.length > 0) {
        this.chartOptions.layout.padding.right = 70;
      }
    }
  }, {
    key: 'setAxis',
    value: function setAxis() {
      var _this4 = this;

      var _props3 = this.props,
          xLabels = _props3.xLabels,
          datasets = _props3.datasets,
          unitLabel = _props3.unitLabel,
          height = _props3.height,
          isBarChart = _props3.isBarChart;
      this.unitLabel = unitLabel;
      this.chartData.labels = xLabels ? xLabels : [];
      var boundries = datasets ? datasets.reduce(function (output, dataset) {
        var max = dataset.data && dataset.data.length > 0 ? Math.max.apply(Math, _toConsumableArray(dataset.data)) : 0;
        var min = dataset.data && dataset.data.length > 0 ? Math.min.apply(Math, _toConsumableArray(dataset.data)) : 999999999;

        if (dataset.datasetType === 'annotation' && dataset.value) {
          max = dataset.value;
          min = max;
        }

        _this4.maxY = Math.max(_this4.maxY, max);
        _this4.minY = Math.min(_this4.minY, min);
        return {
          max: _this4.maxY,
          min: _this4.minY
        };
      }, 0) : {
        max: 0,
        min: 0
      };
      var maxMinForDisplay = boundries.min - Math.floor(0.1 * this.maxY);
      var axis = {
        ticks: {
          steps: 4,
          stepValue: 20,
          maxRotation: 0,
          min: 0,
          callback: function callback(tick) {
            return tick.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          }
        }
      };
      this.chartOptions = _extends({}, this.chartOptions, {
        scaleBeginAtZero: false
      });
      this.chartOptions.scales.yAxes = [_extends({}, scaleYDefaults, axis, {
        stacked: !!isBarChart
      })];
      this.chartOptions.scales.xAxes = [_extends({}, this.chartOptions.scales.xAxes[0], {
        stacked: !!isBarChart
      })];
    }
  }]);

  return ChartContainer;
}(_react.Component);

exports.default = ChartContainer;
module.exports = exports.default;